import {Injectable, makeStateKey} from '@angular/core';
import {Observable, of, tap} from 'rxjs';
import {BlogPost, BlogPostListItem} from '../interfaces/blog';
import {ApiService} from './api.service';

const BLOG_INDEX_KEY = makeStateKey<BlogPostListItem[]>('blog_index');
const BLOG_POST_PREFIX = 'blog_post_';

@Injectable({providedIn: 'root'})
export class BlogService extends ApiService {
    private indexCache: BlogPostListItem[] | null = null;
    private postCache = new Map<string, BlogPost>();

    getPosts(): Observable<BlogPostListItem[]> {
        if (this.indexCache) {
            return of(this.indexCache);
        }

        const transferCached = this.transferState.get(BLOG_INDEX_KEY, null);
        if (transferCached) {
            this.indexCache = transferCached;
            return of(transferCached);
        }

        return this.http.get<BlogPostListItem[]>(`${this.apiHost}/front/blog/index`).pipe(
            tap((items) => {
                this.indexCache = items;
                this.transferState.set(BLOG_INDEX_KEY, items);
            }),
        );
    }

    getPost(slug: string): Observable<BlogPost> {
        const memoryCached = this.postCache.get(slug);
        if (memoryCached) {
            return of(memoryCached);
        }

        const stateKey = makeStateKey<BlogPost>(`${BLOG_POST_PREFIX}${slug}`);
        const transferCached = this.transferState.get(stateKey, null);
        if (transferCached) {
            this.postCache.set(slug, transferCached);
            return of(transferCached);
        }

        return this.http.get<BlogPost>(`${this.apiHost}/front/blog/view?slug=${encodeURIComponent(slug)}`).pipe(
            tap((post) => {
                this.postCache.set(slug, post);
                this.transferState.set(stateKey, post);
            }),
        );
    }
}
